import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { setCurrentClient } from '../../redux/actions/authenticationActions'



class Subheader extends React.Component {

    render() {
        const { clients, currentClient, dispatch } = this.props
       
        if (currentClient !== undefined)
            return (
                <div className="breadcrumbs">
                    <div className="page-header d-flex align-items-center">
                        <div className="container position-relative">
                            <div className="row d-flex justify-content-center">
                                <div className="col-xl-8 col-md-6 text-center">
                                    <select className='customerSelector' style={{ width: '100%', height:'100%' }} value={currentClient.numero} onChange={(value) => { dispatch(setCurrentClient(value.target.value)) }}>
                                        {
                                            clients.map((item, index) => {
                                                return (
                                                    <option className='customerSelectoroption' key={item.numero} value={item.numero}>{item.numero + ':' + item.nom}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-xl-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className='HomeBlock' style={{ height:'100%' }}>
                                        <div style={{ margin: 'auto' }}>
                                            <span>Mon Commercial: {this.props.nomCommercial}</span><br />
                                            <span>Mail: {this.props.emailCommercial}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            )

        else return null
    }


}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        authorized: state.authentication.authorized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        contentHeight: state.app.contentHeight,
        nomCommercial:state.app.nomCommercial,
        emailCommercial:state.app.emailCommercial,
        apiUrl: state.server.apiUrl
    })
}

Subheader.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    authorized: PropTypes.bool,
    serverConfigLoaded: PropTypes.bool,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    contentHeight: PropTypes.number,
    apiUrl: PropTypes.string,
    nomCommercial: PropTypes.string,
    emailCommercial: PropTypes.string,
};

export default connect(mapStateToProps)(Subheader);